import { useRef } from 'react';

interface UseSectionScrollingReturn {
  sectionRefs: React.MutableRefObject<{ [key: string]: HTMLDivElement | null }>;
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  scrollToSection: (sectionId: string) => void;
}

export const useSectionScrolling = (): UseSectionScrollingReturn => {
  // Refs for auto-scrolling to sections
  const sectionRefs = useRef<{ [key: string]: HTMLDivElement | null }>({});
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // Function to scroll to a specific section
  const scrollToSection = (sectionId: string) => {
    const sectionElement = sectionRefs.current[sectionId];
    const scrollContainer = scrollContainerRef.current;
    
    if (!sectionElement) {
      return;
    }

    if (
      scrollContainer &&
      scrollContainer.scrollHeight > scrollContainer.clientHeight + 5
    ) {
      // Get the element's position relative to the scroll container
      const containerRect = scrollContainer.getBoundingClientRect();
      const elementRect = sectionElement.getBoundingClientRect();
      const relativeTop = elementRect.top - containerRect.top + scrollContainer.scrollTop;
      
      // Scroll to the element with some offset
      scrollContainer.scrollTo({
        top: relativeTop - 20, // 20px offset from top
        behavior: 'smooth'
      });
    } else {
      const elementRect = sectionElement.getBoundingClientRect();
      const offset = window.scrollY + elementRect.top - 120; // Account for fixed headers
      window.scrollTo({
        top: offset,
        behavior: 'smooth'
      });
    }
  };

  return {
    sectionRefs,
    scrollContainerRef,
    scrollToSection,
  };
};
